module.exports = __webpack_public_path__ + "img/header_bg.9f41c444.png";